import {
  BatchStatisticsReferenceConditionListItem,
  BatchStatisticsReferenceConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsReferenceConditionListItem'

export interface BatchStatisticsReferenceSelectItemResult {
  items: BatchStatisticsReferenceConditionListItem
}

export function BatchStatisticsReferenceSelectItemResultFromJSON(
  json: any
): BatchStatisticsReferenceSelectItemResult {
  return {
    items: BatchStatisticsReferenceConditionListItemFromJSON(json)
  }
}
